"use client";
import {
  createDisclosureStore
} from "./75BJEVSH.js";

// src/dialog/dialog-store.ts
function createDialogStore(props = {}) {
  return createDisclosureStore(props);
}

export {
  createDialogStore
};
